/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { FlexColumn } from 'design-system';
import {
  buildBrandThemeStyle,
  resolveBrandPrimaryColor,
} from '../../Survey/pages/ClientConnectV2/helpers/brandThemeStyle';
import { selectLearningBrandLogo } from '../../redux/learning/selectors';
import LearningHeader from './LearningHeader';
import WarningBanner from './WarningBanner';

export default function LearningShell({
  children,
  layout = 'intro',
  warningMessage,
  showWarning = true,
}) {
  const intl = useIntl();
  const logoSrc = useSelector(selectLearningBrandLogo);
  const surveyTheme = useSelector((state) => state.survey.survey_theme);
  const brandThemeStyle = buildBrandThemeStyle(resolveBrandPrimaryColor(surveyTheme));
  const resolvedWarning = warningMessage ?? intl.formatMessage({ id: 'ld-progress-warning' });

  return (
    <FlexColumn
      align="stretch"
      fullWidth
      className={`ld-page ld-page--${layout}`}
      style={brandThemeStyle}
    >
      <LearningHeader
        logoSrc={logoSrc}
        title={intl.formatMessage({ id: 'ld-module-title' })}
      />
      <FlexColumn align="stretch" fullWidth className="ld-page__body">
        <FlexColumn
          align="stretch"
          fullWidth
          className={`ld-page__content ld-page__content--${layout}`}
        >
          <main className="ld-page__main">{children}</main>
          {showWarning ? <WarningBanner message={resolvedWarning} /> : null}
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  );
}

LearningShell.propTypes = {
  children: PropTypes.node,
  layout: PropTypes.oneOf(['intro', 'guidance', 'outcome']),
  warningMessage: PropTypes.string,
  showWarning: PropTypes.bool,
};
